import { createStaticApp } from '@ori-appshell/rendering';
import { APP_NAME } from '~/constants-generated';
export default createStaticApp({
    emotionCacheKey: APP_NAME,
    appName: APP_NAME
});
